import { videoObjectsOverviewRoute } from 'pages/NWPlatform/Workspaces/Workspace/Video/Objects'
import { videoStreamObjectsOverviewRoute } from 'pages/NWPlatform/Workspaces/Workspace/Video/Streams/Stream'

export type SortableHeaderRoute = 'objects' | 'streams'

export const useSortableHeaderRoute = (route: SortableHeaderRoute) => {
  if (route === 'objects') {
    return videoObjectsOverviewRoute
  } else {
    return videoStreamObjectsOverviewRoute
  }
}
